import { default as getFavouriteStatus } from "@pb/utils/getFavouriteStatus";
const mapE4Product = (product) => {
    return {
        imageModelSrc: product === null || product === void 0 ? void 0 : product.modelImage,
        imageModelAlt: (product === null || product === void 0 ? void 0 : product.productName) || '',
        imageProductAlt: (product === null || product === void 0 ? void 0 : product.productName) || '',
        title: (product === null || product === void 0 ? void 0 : product.productName) || '',
        isNewProduct: product === null || product === void 0 ? void 0 : product.newArrival,
        showFavoriteButton: true,
        showEnergyButton: false,
        shouldChangeImageOnHover: true,
        brandName: product.brandName || '',
        isOutOfStock: undefined,
        category: product === null || product === void 0 ? void 0 : product.mainCatCode,
        hasPriceMarker: false,
        isExternalBrand: product.external,
        trackingInfo: {
            ticketId: product.trackingId,
        },
        initialFavouriteStatus: getFavouriteStatus((product === null || product === void 0 ? void 0 : product.id) || ''),
        imageProductSrc: (product === null || product === void 0 ? void 0 : product.productImage) || '',
        articleCode: (product === null || product === void 0 ? void 0 : product.id) || '',
        pdpUrl: (product === null || product === void 0 ? void 0 : product.url) || '',
        regularPrice: product === null || product === void 0 ? void 0 : product.prices[0].formattedPrice,
        regularPriceValue: product === null || product === void 0 ? void 0 : product.prices[0].price,
    };
};
export default mapE4Product;
//# sourceMappingURL=mapE4Product.js.map